import React from 'react';
import { FiTrendingUp } from 'react-icons/fi';

/**
 * GrowthIcon
 * Ikona rastu pre sekcie s trendami a grafmi.
 */
const GrowthIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiTrendingUp className={className} {...props} />
);

export default GrowthIcon;

